import { render, staticRenderFns } from "./AppDropdown.vue?vue&type=template&id=5dcbdda5&scoped=true"
import script from "./AppDropdown.vue?vue&type=script&lang=js"
export * from "./AppDropdown.vue?vue&type=script&lang=js"
import style0 from "./AppDropdown.vue?vue&type=style&index=0&id=5dcbdda5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbdda5",
  null
  
)

export default component.exports